import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './_components/dashboard/dashboard.component';
//import { DataDeviceComponent } from './_components/data-device/data-device.component';
import { DataImportComponent } from './_components/data-import/data-import.component';
import { DataRehabComponent } from './_components/data-rehab/data-rehab.component';
import { DataReportComponent } from './_components/data-report/data-report.component';
import { DataViewerComponent } from './_components/data-viewer/data-viewer.component';
import { HomeComponent } from './_components/home/home.component';
import { LoginComponent } from './_components/login/login.component';
import { SettingsComponent } from './_components/settings/settings.component';
import { TemplatesComponent } from './_components/templates/templates.component';
import { UsersComponent } from './_components/users/users.component';
import { UsageTrackingComponent } from './_components/usage-tracking/usage-tracking.component';
import { CacheRefreshComponent } from './_components/cache-refresh/cache-refresh.component';
import { LocationSetUpComponent } from './_components/location-setup/location-setup.component';
import { DashboardV02AComponent } from './_components/dashboardV02A/dashboardV02A.component';
import { DashboardV02ADComponent } from './_components/dashboardV02AD/dashboardV02AD.component';
import { DashboardV02AWComponent } from './_components/dashboardV02AW/dashboardV02AW.component';
import { DashboardV02AMComponent } from './_components/dashboardV02AM/dashboardV02AM.component';
import { DataPatchComponent } from './_components/data-patch/data-patch.component';
import { DashboardFPComponent } from './_components/dashboardFP/dashboardFP.component';
import { DashboardCustomComponent } from './_components/dashboardcustom/dashboardcustom.component';
import { DataReportV02Component } from './_components/data-reportV02/data-reportV02.component';
import { AlertsComponent } from './_components/alerts/alerts.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'dashboardcustom', component: DashboardCustomComponent },
  { path: 'dashboardFP', component: DashboardFPComponent },
  { path: 'dashboardV02A', component: DashboardV02AComponent },
  { path: 'dashboardV02AD', component: DashboardV02ADComponent },
  { path: 'dashboardV02AW', component: DashboardV02AWComponent },
  { path: 'dashboardV02AM', component: DashboardV02AMComponent },
  //{ path: 'data-device', component: DataDeviceComponent },
  { path: 'data-import', component: DataImportComponent },
  { path: 'data-rehab', component: DataRehabComponent },
  { path: 'data-report', component: DataReportComponent },
  { path: 'data-reportV02', component: DataReportV02Component},
  { path: 'data-viewer', component: DataViewerComponent },
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'settings', component: SettingsComponent },
  { path: 'templates', component: TemplatesComponent },
  { path: 'users', component: UsersComponent },
  { path: 'alerts', component: AlertsComponent },
  { path: 'usage-tracking', component: UsageTrackingComponent},
  { path: 'cache-refresh', component: CacheRefreshComponent },
  { path: 'location-setup/:areaId', component: LocationSetUpComponent },
  { path: 'data-patch', component: DataPatchComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
